import validateNoCallOptions from "./validateNoCallOptions";
import { NO_CALL } from "../../../constants";

const buildNoCallParamFromOptions = (
  requestSponsoredProducts = true,
  requestDisplayAdverts = true
) => {
  validateNoCallOptions(requestSponsoredProducts, requestDisplayAdverts);

  if (requestSponsoredProducts && !requestDisplayAdverts) {
    return NO_CALL.sponsoredProducts;
  } else if (!requestSponsoredProducts && requestDisplayAdverts) {
    return NO_CALL.displayAds;
  }

  return null;
};

export default buildNoCallParamFromOptions;
